import isMobilePhone from 'validator/lib/isMobilePhone'

import { TLoginPayload } from '../apis/mutations/use-post-login-mutation'
import isEmailValidator from '../helpers/is-email-validator'

export default function validateLoginForm({ username }: Partial<TLoginPayload>) {
  const errors: Partial<TLoginPayload> = {}

  if (!username) {
    errors.username = 'Please enter your email or phone number to proceed.'
  } else if (!isMobilePhone(username, 'id-ID') && !isEmailValidator(username)) {
    errors.username = 'Invalid email or phone number. Please check and try again.'
  }

  return errors
}
